import TextButtonWithIcon from './TextButtonWithIcon'

export default TextButtonWithIcon
